// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var ListUtils$SmartcutsMacros = require("../../bs-utils/src/ListUtils.bs.js");

function init(oldLen, newLen) {
  var indexOffset = oldLen + newLen | 0;
  return {
          indexOffset: indexOffset,
          contents: Caml_array.make((indexOffset << 1), undefined)
        };
}

function get($$this, diagonalIndex) {
  return Belt_Option.flatMap(Belt_Array.get($$this.contents, diagonalIndex + $$this.indexOffset | 0), (function (x) {
                return x;
              }));
}

function set($$this, diagonalIndex, path) {
  $$this.contents[diagonalIndex + $$this.indexOffset | 0] = path;
  
}

function mapWithDiagonalIndex(f, $$this) {
  return Belt_Array.map(Belt_Array.keepMap(Belt_Array.mapWithIndex($$this.contents, (function (index, maybePath) {
                        return Belt_Option.map(maybePath, (function (path) {
                                      return [
                                              index,
                                              path
                                            ];
                                    }));
                      })), (function (x) {
                    return x;
                  })), (function (param) {
                var diagonalIndex = param[0] - $$this.indexOffset | 0;
                return Curry._2(f, diagonalIndex, param[1]);
              }));
}

var BestPaths = {
  init: init,
  get: get,
  set: set,
  mapWithDiagonalIndex: mapWithDiagonalIndex
};

function Make(Type) {
  var init$1 = function (s1, s2) {
    var oldLen = Curry._1(Type.length, s1);
    var newLen = Curry._1(Type.length, s2);
    var bestPaths = init(oldLen, newLen);
    set(bestPaths, 1, {
          location: [
            0,
            -1
          ],
          components: []
        });
    return {
            s1: s1,
            s2: s2,
            oldLen: oldLen,
            newLen: newLen,
            bestPaths: bestPaths,
            editLength: 0
          };
  };
  var execEditLength = function (context) {
    var editLength = context.editLength;
    var bestPaths = context.bestPaths;
    var newLen = context.newLen;
    var oldLen = context.oldLen;
    var s2 = context.s2;
    var s1 = context.s1;
    var execCommon = function ($$location, components) {
      var y = $$location[1];
      var x = $$location[0];
      var extractCommon = function (x, y) {
        if (x >= oldLen || y >= newLen) {
          return 0;
        }
        var a = Curry._2(Type.get, s1, x);
        var b = Curry._2(Type.get, s2, y);
        if (Curry._2(Type.isIdenticalTo, a, b)) {
          return 1 + extractCommon(x + 1 | 0, y + 1 | 0) | 0;
        } else {
          return 0;
        }
      };
      var d = extractCommon(x, y);
      if (d !== 0) {
        return {
                location: [
                  x + d | 0,
                  y + d | 0
                ],
                components: Belt_Array.concat(components, [{
                        TAG: /* NoEdit */2,
                        _0: [
                          $$location,
                          d
                        ]
                      }])
              };
      } else {
        return {
                location: $$location,
                components: components
              };
      }
    };
    var _diagonalIndex = -editLength | 0;
    while(true) {
      var diagonalIndex = _diagonalIndex;
      if (diagonalIndex > editLength) {
        return ;
      }
      var match = get(bestPaths, diagonalIndex - 1 | 0);
      var match$1 = get(bestPaths, diagonalIndex + 1 | 0);
      var match$2;
      var exit = 0;
      if (diagonalIndex === (-editLength | 0)) {
        var match$3 = match$1 !== undefined ? [
            match$1.location,
            match$1.components
          ] : [
            [
              0,
              editLength
            ],
            []
          ];
        var $$location = match$3[0];
        match$2 = [
          [
            $$location[0],
            $$location[1] + 1 | 0
          ],
          Belt_Array.concat(match$3[1], [{
                  TAG: /* Add */0,
                  _0: [
                    $$location,
                    1
                  ]
                }])
        ];
      } else if (match !== undefined && match$1 !== undefined) {
        var $$location$1 = match$1.location;
        var xRemove = $$location$1[0];
        if (diagonalIndex !== editLength && match.location[0] < xRemove) {
          match$2 = [
            [
              xRemove,
              $$location$1[1] + 1 | 0
            ],
            Belt_Array.concat(match$1.components, [{
                    TAG: /* Add */0,
                    _0: [
                      $$location$1,
                      1
                    ]
                  }])
          ];
        } else {
          exit = 1;
        }
      } else {
        exit = 1;
      }
      if (exit === 1) {
        var match$4 = match !== undefined ? [
            match.location,
            match.components
          ] : [
            [
              editLength,
              0
            ],
            []
          ];
        var $$location$2 = match$4[0];
        match$2 = [
          [
            $$location$2[0] + 1 | 0,
            $$location$2[1]
          ],
          Belt_Array.concat(match$4[1], [{
                  TAG: /* Remove */1,
                  _0: [
                    $$location$2,
                    1
                  ]
                }])
        ];
      }
      var pathByEditAndSnake = execCommon(match$2[0], match$2[1]);
      set(bestPaths, diagonalIndex, pathByEditAndSnake);
      var match$5 = pathByEditAndSnake.location;
      if (match$5[0] >= oldLen && match$5[1] >= newLen) {
        return pathByEditAndSnake.components;
      }
      _diagonalIndex = diagonalIndex + 2 | 0;
      continue ;
    };
  };
  var collapseConsecutiveEdits = function (components) {
    return $$Array.of_list(ListUtils$SmartcutsMacros.collapsePairs((function (c1, c2, _remainingCommands) {
                      switch (c1.TAG | 0) {
                        case /* Add */0 :
                            var match = c1._0;
                            var loc1 = match[0];
                            if (loc1[1] === -1) {
                              return {
                                      TAG: /* ReplaceWith */0,
                                      _0: c2
                                    };
                            }
                            switch (c2.TAG | 0) {
                              case /* Add */0 :
                                  return {
                                          TAG: /* ReplaceWith */0,
                                          _0: {
                                            TAG: /* Add */0,
                                            _0: [
                                              loc1,
                                              match[1] + c2._0[1] | 0
                                            ]
                                          }
                                        };
                              case /* Remove */1 :
                              case /* NoEdit */2 :
                                  return /* KeepBoth */0;
                              
                            }
                        case /* Remove */1 :
                            var match$1 = c1._0;
                            var loc1$1 = match$1[0];
                            if (loc1$1[1] === -1) {
                              return {
                                      TAG: /* ReplaceWith */0,
                                      _0: c2
                                    };
                            }
                            switch (c2.TAG | 0) {
                              case /* Remove */1 :
                                  return {
                                          TAG: /* ReplaceWith */0,
                                          _0: {
                                            TAG: /* Remove */1,
                                            _0: [
                                              loc1$1,
                                              match$1[1] + c2._0[1] | 0
                                            ]
                                          }
                                        };
                              case /* Add */0 :
                              case /* NoEdit */2 :
                                  return /* KeepBoth */0;
                              
                            }
                        case /* NoEdit */2 :
                            return /* KeepBoth */0;
                        
                      }
                    }), $$Array.to_list(components)));
  };
  var populateEditScriptWithValues = function (context, component) {
    var s1 = context.s1;
    switch (component.TAG | 0) {
      case /* Add */0 :
          var match = component._0;
          return {
                  TAG: /* Add */0,
                  _0: Curry._3(Type.slice, context.s2, match[0][1], match[1])
                };
      case /* Remove */1 :
          var match$1 = component._0;
          return {
                  TAG: /* Remove */1,
                  _0: Curry._3(Type.slice, s1, match$1[0][0], match$1[1])
                };
      case /* NoEdit */2 :
          var match$2 = component._0;
          return {
                  TAG: /* NoEdit */2,
                  _0: Curry._3(Type.slice, s1, match$2[0][0], match$2[1])
                };
      
    }
  };
  var findShortestEditScript = function (s1, s2) {
    var search = function (_context) {
      while(true) {
        var context = _context;
        var result = execEditLength(context);
        if (result !== undefined) {
          return [
                  result,
                  context
                ];
        }
        _context = {
          s1: context.s1,
          s2: context.s2,
          oldLen: context.oldLen,
          newLen: context.newLen,
          bestPaths: context.bestPaths,
          editLength: context.editLength + 1 | 0
        };
        continue ;
      };
    };
    var match = search(init$1(s1, s2));
    var context = match[1];
    return Belt_Array.map(collapseConsecutiveEdits(match[0]), (function (param) {
                  return populateEditScriptWithValues(context, param);
                }));
  };
  return {
          init: init$1,
          execEditLength: execEditLength,
          collapseConsecutiveEdits: collapseConsecutiveEdits,
          populateEditScriptWithValues: populateEditScriptWithValues,
          findShortestEditScript: findShortestEditScript
        };
}

function slice(str, from, len) {
  return str.slice(from, from + len | 0);
}

function init$1(s1, s2) {
  var oldLen = s1.length;
  var newLen = s2.length;
  var bestPaths = init(oldLen, newLen);
  set(bestPaths, 1, {
        location: [
          0,
          -1
        ],
        components: []
      });
  return {
          s1: s1,
          s2: s2,
          oldLen: oldLen,
          newLen: newLen,
          bestPaths: bestPaths,
          editLength: 0
        };
}

function execEditLength(context) {
  var editLength = context.editLength;
  var bestPaths = context.bestPaths;
  var newLen = context.newLen;
  var oldLen = context.oldLen;
  var s2 = context.s2;
  var s1 = context.s1;
  var execCommon = function ($$location, components) {
    var y = $$location[1];
    var x = $$location[0];
    var extractCommon = function (x, y) {
      if (x >= oldLen || y >= newLen) {
        return 0;
      }
      var a = s1.charAt(x);
      var b = s2.charAt(y);
      if (Caml_obj.caml_equal(a, b)) {
        return 1 + extractCommon(x + 1 | 0, y + 1 | 0) | 0;
      } else {
        return 0;
      }
    };
    var d = extractCommon(x, y);
    if (d !== 0) {
      return {
              location: [
                x + d | 0,
                y + d | 0
              ],
              components: Belt_Array.concat(components, [{
                      TAG: /* NoEdit */2,
                      _0: [
                        $$location,
                        d
                      ]
                    }])
            };
    } else {
      return {
              location: $$location,
              components: components
            };
    }
  };
  var _diagonalIndex = -editLength | 0;
  while(true) {
    var diagonalIndex = _diagonalIndex;
    if (diagonalIndex > editLength) {
      return ;
    }
    var match = get(bestPaths, diagonalIndex - 1 | 0);
    var match$1 = get(bestPaths, diagonalIndex + 1 | 0);
    var match$2;
    var exit = 0;
    if (diagonalIndex === (-editLength | 0)) {
      var match$3 = match$1 !== undefined ? [
          match$1.location,
          match$1.components
        ] : [
          [
            0,
            editLength
          ],
          []
        ];
      var $$location = match$3[0];
      match$2 = [
        [
          $$location[0],
          $$location[1] + 1 | 0
        ],
        Belt_Array.concat(match$3[1], [{
                TAG: /* Add */0,
                _0: [
                  $$location,
                  1
                ]
              }])
      ];
    } else if (match !== undefined && match$1 !== undefined) {
      var $$location$1 = match$1.location;
      var xRemove = $$location$1[0];
      if (diagonalIndex !== editLength && match.location[0] < xRemove) {
        match$2 = [
          [
            xRemove,
            $$location$1[1] + 1 | 0
          ],
          Belt_Array.concat(match$1.components, [{
                  TAG: /* Add */0,
                  _0: [
                    $$location$1,
                    1
                  ]
                }])
        ];
      } else {
        exit = 1;
      }
    } else {
      exit = 1;
    }
    if (exit === 1) {
      var match$4 = match !== undefined ? [
          match.location,
          match.components
        ] : [
          [
            editLength,
            0
          ],
          []
        ];
      var $$location$2 = match$4[0];
      match$2 = [
        [
          $$location$2[0] + 1 | 0,
          $$location$2[1]
        ],
        Belt_Array.concat(match$4[1], [{
                TAG: /* Remove */1,
                _0: [
                  $$location$2,
                  1
                ]
              }])
      ];
    }
    var pathByEditAndSnake = execCommon(match$2[0], match$2[1]);
    set(bestPaths, diagonalIndex, pathByEditAndSnake);
    var match$5 = pathByEditAndSnake.location;
    if (match$5[0] >= oldLen && match$5[1] >= newLen) {
      return pathByEditAndSnake.components;
    }
    _diagonalIndex = diagonalIndex + 2 | 0;
    continue ;
  };
}

function collapseConsecutiveEdits(components) {
  return $$Array.of_list(ListUtils$SmartcutsMacros.collapsePairs((function (c1, c2, _remainingCommands) {
                    switch (c1.TAG | 0) {
                      case /* Add */0 :
                          var match = c1._0;
                          var loc1 = match[0];
                          if (loc1[1] === -1) {
                            return {
                                    TAG: /* ReplaceWith */0,
                                    _0: c2
                                  };
                          }
                          switch (c2.TAG | 0) {
                            case /* Add */0 :
                                return {
                                        TAG: /* ReplaceWith */0,
                                        _0: {
                                          TAG: /* Add */0,
                                          _0: [
                                            loc1,
                                            match[1] + c2._0[1] | 0
                                          ]
                                        }
                                      };
                            case /* Remove */1 :
                            case /* NoEdit */2 :
                                return /* KeepBoth */0;
                            
                          }
                      case /* Remove */1 :
                          var match$1 = c1._0;
                          var loc1$1 = match$1[0];
                          if (loc1$1[1] === -1) {
                            return {
                                    TAG: /* ReplaceWith */0,
                                    _0: c2
                                  };
                          }
                          switch (c2.TAG | 0) {
                            case /* Remove */1 :
                                return {
                                        TAG: /* ReplaceWith */0,
                                        _0: {
                                          TAG: /* Remove */1,
                                          _0: [
                                            loc1$1,
                                            match$1[1] + c2._0[1] | 0
                                          ]
                                        }
                                      };
                            case /* Add */0 :
                            case /* NoEdit */2 :
                                return /* KeepBoth */0;
                            
                          }
                      case /* NoEdit */2 :
                          return /* KeepBoth */0;
                      
                    }
                  }), $$Array.to_list(components)));
}

function populateEditScriptWithValues(context, component) {
  var s1 = context.s1;
  switch (component.TAG | 0) {
    case /* Add */0 :
        var match = component._0;
        return {
                TAG: /* Add */0,
                _0: slice(context.s2, match[0][1], match[1])
              };
    case /* Remove */1 :
        var match$1 = component._0;
        return {
                TAG: /* Remove */1,
                _0: slice(s1, match$1[0][0], match$1[1])
              };
    case /* NoEdit */2 :
        var match$2 = component._0;
        return {
                TAG: /* NoEdit */2,
                _0: slice(s1, match$2[0][0], match$2[1])
              };
    
  }
}

function findShortestEditScript(s1, s2) {
  var search = function (_context) {
    while(true) {
      var context = _context;
      var result = execEditLength(context);
      if (result !== undefined) {
        return [
                result,
                context
              ];
      }
      _context = {
        s1: context.s1,
        s2: context.s2,
        oldLen: context.oldLen,
        newLen: context.newLen,
        bestPaths: context.bestPaths,
        editLength: context.editLength + 1 | 0
      };
      continue ;
    };
  };
  var match = search(init$1(s1, s2));
  var context = match[1];
  return Belt_Array.map(collapseConsecutiveEdits(match[0]), (function (param) {
                return populateEditScriptWithValues(context, param);
              }));
}

var Debug = {
  init: init$1,
  execEditLength: execEditLength,
  collapseConsecutiveEdits: collapseConsecutiveEdits,
  populateEditScriptWithValues: populateEditScriptWithValues
};

var $$String = {
  findShortestEditScript: findShortestEditScript,
  Debug: Debug
};

function MakeArray(Item) {
  var isIdenticalTo = Item.isIdenticalTo;
  var init$2 = function (s1, s2) {
    var oldLen = s1.length;
    var newLen = s2.length;
    var bestPaths = init(oldLen, newLen);
    set(bestPaths, 1, {
          location: [
            0,
            -1
          ],
          components: []
        });
    return {
            s1: s1,
            s2: s2,
            oldLen: oldLen,
            newLen: newLen,
            bestPaths: bestPaths,
            editLength: 0
          };
  };
  var execEditLength = function (context) {
    var editLength = context.editLength;
    var bestPaths = context.bestPaths;
    var newLen = context.newLen;
    var oldLen = context.oldLen;
    var s2 = context.s2;
    var s1 = context.s1;
    var execCommon = function ($$location, components) {
      var y = $$location[1];
      var x = $$location[0];
      var extractCommon = function (x, y) {
        if (x >= oldLen || y >= newLen) {
          return 0;
        }
        var a = Caml_array.get(s1, x);
        var b = Caml_array.get(s2, y);
        if (Curry._2(isIdenticalTo, a, b)) {
          return 1 + extractCommon(x + 1 | 0, y + 1 | 0) | 0;
        } else {
          return 0;
        }
      };
      var d = extractCommon(x, y);
      if (d !== 0) {
        return {
                location: [
                  x + d | 0,
                  y + d | 0
                ],
                components: Belt_Array.concat(components, [{
                        TAG: /* NoEdit */2,
                        _0: [
                          $$location,
                          d
                        ]
                      }])
              };
      } else {
        return {
                location: $$location,
                components: components
              };
      }
    };
    var _diagonalIndex = -editLength | 0;
    while(true) {
      var diagonalIndex = _diagonalIndex;
      if (diagonalIndex > editLength) {
        return ;
      }
      var match = get(bestPaths, diagonalIndex - 1 | 0);
      var match$1 = get(bestPaths, diagonalIndex + 1 | 0);
      var match$2;
      var exit = 0;
      if (diagonalIndex === (-editLength | 0)) {
        var match$3 = match$1 !== undefined ? [
            match$1.location,
            match$1.components
          ] : [
            [
              0,
              editLength
            ],
            []
          ];
        var $$location = match$3[0];
        match$2 = [
          [
            $$location[0],
            $$location[1] + 1 | 0
          ],
          Belt_Array.concat(match$3[1], [{
                  TAG: /* Add */0,
                  _0: [
                    $$location,
                    1
                  ]
                }])
        ];
      } else if (match !== undefined && match$1 !== undefined) {
        var $$location$1 = match$1.location;
        var xRemove = $$location$1[0];
        if (diagonalIndex !== editLength && match.location[0] < xRemove) {
          match$2 = [
            [
              xRemove,
              $$location$1[1] + 1 | 0
            ],
            Belt_Array.concat(match$1.components, [{
                    TAG: /* Add */0,
                    _0: [
                      $$location$1,
                      1
                    ]
                  }])
          ];
        } else {
          exit = 1;
        }
      } else {
        exit = 1;
      }
      if (exit === 1) {
        var match$4 = match !== undefined ? [
            match.location,
            match.components
          ] : [
            [
              editLength,
              0
            ],
            []
          ];
        var $$location$2 = match$4[0];
        match$2 = [
          [
            $$location$2[0] + 1 | 0,
            $$location$2[1]
          ],
          Belt_Array.concat(match$4[1], [{
                  TAG: /* Remove */1,
                  _0: [
                    $$location$2,
                    1
                  ]
                }])
        ];
      }
      var pathByEditAndSnake = execCommon(match$2[0], match$2[1]);
      set(bestPaths, diagonalIndex, pathByEditAndSnake);
      var match$5 = pathByEditAndSnake.location;
      if (match$5[0] >= oldLen && match$5[1] >= newLen) {
        return pathByEditAndSnake.components;
      }
      _diagonalIndex = diagonalIndex + 2 | 0;
      continue ;
    };
  };
  var collapseConsecutiveEdits = function (components) {
    return $$Array.of_list(ListUtils$SmartcutsMacros.collapsePairs((function (c1, c2, _remainingCommands) {
                      switch (c1.TAG | 0) {
                        case /* Add */0 :
                            var match = c1._0;
                            var loc1 = match[0];
                            if (loc1[1] === -1) {
                              return {
                                      TAG: /* ReplaceWith */0,
                                      _0: c2
                                    };
                            }
                            switch (c2.TAG | 0) {
                              case /* Add */0 :
                                  return {
                                          TAG: /* ReplaceWith */0,
                                          _0: {
                                            TAG: /* Add */0,
                                            _0: [
                                              loc1,
                                              match[1] + c2._0[1] | 0
                                            ]
                                          }
                                        };
                              case /* Remove */1 :
                              case /* NoEdit */2 :
                                  return /* KeepBoth */0;
                              
                            }
                        case /* Remove */1 :
                            var match$1 = c1._0;
                            var loc1$1 = match$1[0];
                            if (loc1$1[1] === -1) {
                              return {
                                      TAG: /* ReplaceWith */0,
                                      _0: c2
                                    };
                            }
                            switch (c2.TAG | 0) {
                              case /* Remove */1 :
                                  return {
                                          TAG: /* ReplaceWith */0,
                                          _0: {
                                            TAG: /* Remove */1,
                                            _0: [
                                              loc1$1,
                                              match$1[1] + c2._0[1] | 0
                                            ]
                                          }
                                        };
                              case /* Add */0 :
                              case /* NoEdit */2 :
                                  return /* KeepBoth */0;
                              
                            }
                        case /* NoEdit */2 :
                            return /* KeepBoth */0;
                        
                      }
                    }), $$Array.to_list(components)));
  };
  var findShortestEditScript = function (s1, s2) {
    var search = function (_context) {
      while(true) {
        var context = _context;
        var result = execEditLength(context);
        if (result !== undefined) {
          return [
                  result,
                  context
                ];
        }
        _context = {
          s1: context.s1,
          s2: context.s2,
          oldLen: context.oldLen,
          newLen: context.newLen,
          bestPaths: context.bestPaths,
          editLength: context.editLength + 1 | 0
        };
        continue ;
      };
    };
    var match = search(init$2(s1, s2));
    var context = match[1];
    return Belt_Array.map(collapseConsecutiveEdits(match[0]), (function (param) {
                  var s1 = context.s1;
                  switch (param.TAG | 0) {
                    case /* Add */0 :
                        var match = param._0;
                        return {
                                TAG: /* Add */0,
                                _0: Belt_Array.slice(context.s2, match[0][1], match[1])
                              };
                    case /* Remove */1 :
                        var match$1 = param._0;
                        return {
                                TAG: /* Remove */1,
                                _0: Belt_Array.slice(s1, match$1[0][0], match$1[1])
                              };
                    case /* NoEdit */2 :
                        var match$2 = param._0;
                        return {
                                TAG: /* NoEdit */2,
                                _0: Belt_Array.slice(s1, match$2[0][0], match$2[1])
                              };
                    
                  }
                }));
  };
  return {
          findShortestEditScript: findShortestEditScript
        };
}

function commandContent(command) {
  return command._0;
}

function findArrangements(editScript) {
  var _arrangmentsOpt;
  var _indexOpt;
  var _param;
  while(true) {
    var arrangmentsOpt = _arrangmentsOpt;
    var indexOpt = _indexOpt;
    var arrangments = arrangmentsOpt !== undefined ? arrangmentsOpt : [[]];
    var index = indexOpt !== undefined ? indexOpt : 0;
    var match = Belt_Array.get(editScript, index);
    var match$1 = Belt_Array.get(editScript, index + 1 | 0);
    if (match === undefined) {
      return arrangments;
    }
    switch (match.TAG | 0) {
      case /* Remove */1 :
          if (match$1 !== undefined) {
            var removed = match._0;
            switch (match$1.TAG | 0) {
              case /* Add */0 :
                  var added = match$1._0;
                  _param = undefined;
                  _indexOpt = index + 2 | 0;
                  _arrangmentsOpt = Belt_Array.concat(Belt_Array.map(arrangments, (function(removed,added){
                          return function (propertySchemas) {
                            return Belt_Array.concat(Belt_Array.concat(propertySchemas, removed), added);
                          }
                          }(removed,added))), Belt_Array.map(arrangments, (function(removed,added){
                          return function (propertySchemas) {
                            return Belt_Array.concat(Belt_Array.concat(propertySchemas, added), removed);
                          }
                          }(removed,added))));
                  continue ;
              case /* Remove */1 :
              case /* NoEdit */2 :
                  break;
              
            }
          }
          break;
      case /* Add */0 :
      case /* NoEdit */2 :
          break;
      
    }
    if (match$1 === undefined) {
      return Belt_Array.map(arrangments, (function(match){
                return function (propertySchemas) {
                  return Belt_Array.concat(propertySchemas, match._0);
                }
                }(match)));
    }
    _param = undefined;
    _indexOpt = index + 1 | 0;
    _arrangmentsOpt = Belt_Array.map(arrangments, (function(match){
        return function (propertySchemas) {
          return Belt_Array.concat(propertySchemas, match._0);
        }
        }(match)));
    continue ;
  };
}

exports.BestPaths = BestPaths;
exports.Make = Make;
exports.$$String = $$String;
exports.MakeArray = MakeArray;
exports.commandContent = commandContent;
exports.findArrangements = findArrangements;
/* No side effect */
